// extracted by mini-css-extract-plugin
export default {"issueDetails":"G43e11e","button":"G86c16c"};